import { useState, useEffect, useRef } from "react";
import apiService from "../config";

// ── Icons ──────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
  </svg>
);
const DocIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);
const FilterIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);
const ChevronDown = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const ChevronLeft = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightNav = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const ChevronsLeft = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="11 17 6 12 11 7" /><polyline points="18 17 13 12 18 7" />
  </svg>
);
const ChevronsRight = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="13 17 18 12 13 7" /><polyline points="6 17 11 12 6 7" />
  </svg>
);
const ImageIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);
const DownloadIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
const ZoomInIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    <line x1="11" y1="8" x2="11" y2="14" /><line x1="8" y1="11" x2="14" y2="11" />
  </svg>
);
const ZoomOutIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    <line x1="8" y1="11" x2="14" y2="11" />
  </svg>
);
const RotateIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);
const LayersIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
  </svg>
);
const TableIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" /><line x1="9" y1="9" x2="9" y2="21" /><line x1="15" y1="9" x2="15" y2="21" />
  </svg>
);
const InfoIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);
const UsersIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

function WatermarkOverlay() {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const yyyy = now.getFullYear();
  const hh = now.getHours() % 12 || 12;
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");
  const ampm = now.getHours() >= 12 ? "PM" : "AM";

  return (
    <div style={{
      position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
      pointerEvents: "none", userSelect: "none", zIndex: 10, overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%) rotate(-35deg)",
        fontSize: 22,
        fontWeight: 900,
        color: "rgba(0,0,0,0.18)",
        whiteSpace: "nowrap",
        letterSpacing: "0.06em",
        fontFamily: "'Noto Sans Devanagari', 'DM Sans', sans-serif",
        width: "160%",
        textAlign: "center",
        lineHeight: 1.4,
      }}>
        © फक्त कार्यालयीन कामासाठी नि-शुल्क प्रत
      </div>
      <div style={{
        position: "absolute", bottom: 0, left: 0, padding: "8px 12px",
        fontFamily: "'Noto Sans Devanagari', 'DM Sans', sans-serif",
        display: "flex", flexDirection: "column", gap: 2,
      }}>
        {[
          "सादर दस्तावेज हा केवळ अंतगर्त शासकीय कार्यवाहीसाठी उपलब्ध आहे.",
          "खाजगी वापर केल्यास योग्य उचित दंड/शिक्षा केली जाईल याची नोंद ध्यायी.",
          `दिनांक: ${dd}-${mm}-${yyyy} ${String(hh).padStart(2, "0")}:${min}:${ss} ${ampm}`,
        ].map((txt, i) => (
          <span key={i} style={{
            fontSize: 12,
            fontWeight: i < 2 ? 700 : 600,
            color: "rgba(0,0,0,0.22)",
            lineHeight: 1.6,
            display: "block",
            whiteSpace: "nowrap",
          }}>{txt}</span>
        ))}
      </div>
    </div>
  );
}

// ── CollapsedTab ───────────────────────────────────────────────
function CollapsedTab({ label, icon, onClick }) {
  return (
    <div onClick={onClick} className="vd-collapsed-tab"
      style={{ width: 28, flexShrink: 0, background: "#fff", borderRight: "1px solid #e2e8f0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", paddingTop: 14, cursor: "pointer", userSelect: "none" }}>
      <span style={{ color: "#94a3b8", marginBottom: 8 }}>{icon}</span>
      <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#94a3b8", writingMode: "vertical-rl", transform: "rotate(180deg)", whiteSpace: "nowrap" }}>{label}</span>
    </div>
  );
}

// ── OwnersPanel ────────────────────────────────────────────────
function OwnersPanel({ prakaranKramank }) {
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ownerSearch, setOwnerSearch] = useState("");

  useEffect(() => {
    if (!prakaranKramank) return;
    setLoading(true); setError(null); setOwners([]);
    apiService.getNivadaOwner({ prakaranKkramank: prakaranKramank })
      .then(res => setOwners(res?.data || []))
      .catch(() => setError("Owner माहिती लोड करताना त्रुटी आली."))
      .finally(() => setLoading(false));
  }, [prakaranKramank]);

  const filtered = ownerSearch.trim()
    ? owners.filter(o => o.owner_name?.toLowerCase().includes(ownerSearch.toLowerCase()) || o.survey_no?.toLowerCase().includes(ownerSearch.toLowerCase()))
    : owners;

  return (
    <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", marginTop: 14, boxShadow: "0 1px 3px rgba(0,0,0,.04)", overflow: "hidden" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderBottom: "1px solid #f1f5f9", background: "#f8fafc" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 15, fontWeight: 700, color: "#1e293b" }}>
          <UsersIcon /><span>मालक यादी</span>
          {!loading && owners.length > 0 && (
            <span style={{ background: "#eff6ff", color: "#1d4ed8", fontSize: 13, fontWeight: 700, padding: "1px 7px", borderRadius: 99 }}>{owners.length}</span>
          )}
        </div>
        {prakaranKramank && (
          <span style={{ fontSize: 10, color: "#94a3b8", background: "#f1f5f9", padding: "2px 8px", borderRadius: 99, fontWeight: 600 }}>{prakaranKramank}</span>
        )}
      </div>
      {owners.length > 0 && (
        <div style={{ padding: "8px 12px", borderBottom: "1px solid #f1f5f9" }}>
          <div style={{ position: "relative" }}>
            <span style={{ position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }}><SearchIcon /></span>
            <input value={ownerSearch} onChange={e => setOwnerSearch(e.target.value)} placeholder="नाव किंवा सर्व्हे नं शोधा..."
              style={{ width: "100%", boxSizing: "border-box", fontSize: 12, paddingLeft: 28, paddingRight: 8, paddingTop: 5, paddingBottom: 5, border: "1px solid #e2e8f0", borderRadius: 6, background: "#f8fafc", outline: "none", color: "#334155", fontFamily: "inherit" }} />
            {ownerSearch && (
              <button onClick={() => setOwnerSearch("")} style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 0 }}>
                <CloseIcon />
              </button>
            )}
          </div>
          {ownerSearch && <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>{filtered.length} of {owners.length} owners</div>}
        </div>
      )}
      {loading ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "20px 16px", color: "#64748b", fontSize: 12 }}>
          <div className="vd-spin" style={{ width: 14, height: 14, border: "2px solid #e2e8f0", borderTopColor: "#1d4ed8", borderRadius: "50%" }} />
          Owner माहिती लोड होत आहे...
        </div>
      ) : error ? (
        <div style={{ padding: "16px", textAlign: "center", color: "#ef4444", fontSize: 12 }}>{error}</div>
      ) : owners.length === 0 ? (
        <div style={{ padding: "16px", textAlign: "center", color: "#94a3b8", fontSize: 12 }}>कोणताही मालक आढळला नाही</div>
      ) : (
        <div className="vd-scroll" style={{ maxHeight: 280, overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
            <thead>
              <tr style={{ background: "#f8fafc", position: "sticky", top: 0, zIndex: 5 }}>
                {["#", "मालकाचे नाव", "सर्व्हे नं", "एकूण क्षेत्र", "संपादन क्षेत्र", "जिल्हा", "तालुका", "गाव"].map(h => (
                  <th key={h} style={{ padding: "6px 10px", textAlign: "left", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".05em", color: "#64748b", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((owner, idx) => (
                <tr key={owner.ID ?? idx} className="vd-owner-row" style={{ borderBottom: "1px solid #f8fafc" }}>
                  <td style={{ padding: "6px 10px", color: "#94a3b8", fontSize: 10, fontWeight: 600 }}>
                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 20, height: 20, background: "linear-gradient(135deg,#eff6ff,#dbeafe)", borderRadius: "50%", fontSize: 9, fontWeight: 700, color: "#1d4ed8" }}>{idx + 1}</span>
                  </td>
                  <td style={{ padding: "6px 10px", fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                    <span style={{ fontSize: 12, fontWeight: 600, color: "#1e293b" }}>{owner.owner_name || "—"}</span>
                  </td>
                  <td style={{ padding: "6px 10px" }}>
                    {owner.survey_no ? <span style={{ background: "#f0fdf4", color: "#166534", border: "1px solid #bbf7d0", borderRadius: 99, padding: "1px 7px", fontSize: 11, fontWeight: 600 }}>{owner.survey_no}</span>
                      : <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}
                  </td>
                  <td style={{ padding: "6px 10px", color: "#475569", fontSize: 11 }}>
                    {owner.TotalArea != null ? <span style={{ fontWeight: 600 }}>{owner.TotalArea}</span> : <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}
                  </td>
                  <td style={{ padding: "6px 10px", color: "#475569", fontSize: 11 }}>
                    {owner.aqr_area != null ? <span style={{ fontWeight: 600 }}>{owner.aqr_area}</span> : <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}
                  </td>
                  <td style={{ padding: "6px 10px", fontSize: 11, color: "#475569", fontFamily: "'Noto Sans Devanagari', sans-serif" }}>{owner.dist_name || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</td>
                  <td style={{ padding: "6px 10px", fontSize: 11, color: "#475569", fontFamily: "'Noto Sans Devanagari', sans-serif" }}>{owner.taluka_name || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</td>
                  <td style={{ padding: "6px 10px", fontSize: 11, color: "#475569", fontFamily: "'Noto Sans Devanagari', sans-serif" }}>{owner.village_name || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── TotalCountTable ────────────────────────────────────────────
function TotalCountTable({ data, loading, error, totalCount, totalPages, currentPage, selectedRow, onRowClick, onPageChange, mode, pageSize }) {
  const getPageNumbers = () => {
    const d = 2, l = Math.max(1, currentPage - d), r = Math.min(totalPages, currentPage + d);
    return Array.from({ length: r - l + 1 }, (_, i) => l + i);
  };
  const pageBtn = (onClick, disabled, children, active = false) => (
    <button onClick={onClick} disabled={disabled} className={active ? "" : "vd-page-btn"}
      style={{ width: 26, height: 26, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 4, border: "1px solid", fontSize: 11, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.4 : 1, transition: "all .15s", borderColor: active ? "#1d4ed8" : "#e2e8f0", background: active ? "#1d4ed8" : "#fff", color: active ? "#fff" : "#475569" }}>
      {children}
    </button>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <div className="vd-scroll" style={{ flex: 1, overflowY: "auto" }}>
        {loading ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 40, color: "#64748b", fontSize: 13, gap: 8 }}>
            <div className="vd-spin" style={{ width: 16, height: 16, border: "2px solid #e2e8f0", borderTopColor: "#1d4ed8", borderRadius: "50%" }} />
            माहिती लोड होत आहे...
          </div>
        ) : error ? (
          <div style={{ padding: 16, textAlign: "center", color: "#ef4444", fontSize: 13 }}>{error}</div>
        ) : data.length === 0 ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, padding: "40px 20px", color: "#94a3b8" }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#64748b" }}>No results found</div>
            <div style={{ fontSize: 12 }}>वेगळे filters वापरून पुन्हा प्रयत्न करा</div>
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr style={{ background: "#f8fafc", position: "sticky", top: 0, zIndex: 10 }}>
                {(mode === "public"
                  ? ["#", "Document Type","District", "Taluka", "Village", "Project Name", "Prakaran Kramank", "Total", "Office Name"]
                  : ["#", "Document Type", "Project Name", "Prakaran Kramank", "Total", "Office Name"]
                ).map(h => (
                  <th key={h} style={{ padding: "7px 10px", textAlign: "left", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em", color: "#64748b", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                const isActive = selectedRow && selectedRow._idx === idx;
                const activeBg = isActive ? "#dbeafe" : undefined;
                const activeBorder = isActive ? "3px solid #1a4480" : "3px solid transparent";
                return (
                  <tr key={idx} className="vd-table-row vd-total-row" onClick={() => onRowClick({ ...row, _idx: idx })} style={{ cursor: "pointer" }}>
                    <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", color: "#94a3b8", fontSize: 12, fontWeight: 600, background: activeBg, borderLeft: activeBorder }}>{idx + 1}</td>
                    {mode === "public" ? (
                      <>
                       <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 180, background: activeBg }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: isActive ? "#1d4ed8" : "#1e293b", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.NVD_doctype || "-"}>
                          {row.NVD_doctype ? row.NVD_doctype.replace(/^\d+\.\s*/, "") : <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}
                        </span>
                      </td>
                        <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 120, background: activeBg }}><span style={{ fontSize: 11, color: "#475569", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.district || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</span></td>
                        <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 120, background: activeBg }}><span style={{ fontSize: 11, color: "#475569", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.tahsil || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</span></td>
                        <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 120, background: activeBg }}><span style={{ fontSize: 11, color: "#475569", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.village || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</span></td>
                      </>
                    ) : (
                      <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 180, background: activeBg }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: isActive ? "#1d4ed8" : "#1e293b", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.NVD_doctype || "-"}>
                          {row.NVD_doctype ? row.NVD_doctype.replace(/^\d+\.\s*/, "") : <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}
                        </span>
                      </td>
                    )}
                    <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 140, background: activeBg }}><span style={{ fontSize: 11, color: "#475569", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.master_project_name || "-"}>{row.master_project_name || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</span></td>
                    <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", background: activeBg }}>
                      {row.NVD_Prakaran_kramank ? <span style={{ display: "inline-block", fontSize: 11, padding: "1px 7px", borderRadius: 99, fontWeight: 600, background: "#f0fdf4", color: "#166534", border: "1px solid #bbf7d0", whiteSpace: "nowrap" }}>{row.NVD_Prakaran_kramank}</span>
                        : <span style={{ color: "#cbd5e1", fontStyle: "italic", fontSize: 11 }}>—</span>}
                    </td>
                    <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", background: activeBg }}>
                      <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 36, padding: "2px 8px", borderRadius: 6, fontSize: 12, fontWeight: 700, background: "#eff6ff", color: "#1d4ed8" }}>{(row.TOTAL || 0).toLocaleString()}</span>
                    </td>
                    <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9", maxWidth: 140, background: activeBg }}><span style={{ fontSize: 11, color: "#475569", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.Nvd_office || "-"}>{row.Nvd_office || <span style={{ color: "#cbd5e1", fontStyle: "italic" }}>—</span>}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      {totalPages > 1 && !loading && (
        <div style={{ flexShrink: 0, borderTop: "1px solid #f1f5f9", background: "#fff", padding: "6px 10px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
          <span style={{ fontSize: 10, color: "#94a3b8", whiteSpace: "nowrap" }}>{((currentPage - 1) * pageSize) + 1}–{Math.min(currentPage * pageSize, totalCount)} of {totalCount.toLocaleString()}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
            {pageBtn(() => onPageChange(1), currentPage === 1, <ChevronsLeft />)}
            {pageBtn(() => onPageChange(currentPage - 1), currentPage === 1, <ChevronLeft />)}
            {getPageNumbers().map(p => pageBtn(() => onPageChange(p), p === currentPage, p, p === currentPage))}
            {pageBtn(() => onPageChange(currentPage + 1), currentPage === totalPages, <ChevronRightNav />)}
            {pageBtn(() => onPageChange(totalPages), currentPage === totalPages, <ChevronsRight />)}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ fontSize: 10, color: "#94a3b8" }}>Go</span>
            <input type="number" min={1} max={totalPages}
              style={{ width: 38, fontSize: 11, textAlign: "center", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 4, padding: "2px 2px", outline: "none" }}
              placeholder={String(currentPage)}
              onKeyDown={e => { if (e.key === "Enter") { const v = parseInt(e.target.value); if (v >= 1 && v <= totalPages) onPageChange(v); e.target.value = ""; } }} />
          </div>
        </div>
      )}
    </div>
  );
}

function ImageListModal({ allDocs, initialDocIdx, initialImg, fetchImage, onClose }) {
  const [cache, setCache] = useState(() => ({ [initialDocIdx]: initialImg }));
  const [current, setCurrent] = useState(initialDocIdx);
  const [loading, setLoading] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [naturalSize, setNaturalSize] = useState({ w: 0, h: 0 });
  const scrollRef = useRef(null);
  const imgRef = useRef(null);
  const total = allDocs.length;
  const img = cache[current] ?? null;

  const goTo = async (idx) => {
    if (idx < 0 || idx >= total) return;
    setZoom(1); setRotation(0); setNaturalSize({ w: 0, h: 0 });
    setCurrent(idx);
    if (cache[idx]) return;
    setLoading(true);
    try {
      const doc = allDocs[idx];
      const imgObj = await fetchImage(doc.volume_no, doc.PAGE_NO);
      if (imgObj) setCache(prev => ({ ...prev, [idx]: imgObj }));
    } catch { }
    finally { setLoading(false); }
  };

  useEffect(() => { setZoom(1); setRotation(0); setNaturalSize({ w: 0, h: 0 }); }, [current]);

  useEffect(() => {
    const handler = e => {
      if (e.key === "ArrowRight" || e.key === "ArrowDown") goTo(current + 1);
      else if (e.key === "ArrowLeft" || e.key === "ArrowUp") goTo(current - 1);
      else if (e.key === "Escape") onClose();
      else if (e.key === "+" || e.key === "=") setZoom(z => Math.min(z + 0.25, 5));
      else if (e.key === "-") setZoom(z => Math.max(z - 0.25, 0.25));
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [current, total, onClose]);

  useEffect(() => {
    if (scrollRef.current) {
      const el = scrollRef.current.querySelector(`[data-idx="${current}"]`);
      if (el) el.scrollIntoView({ block: "nearest" });
    }
  }, [current]);

  const getUrl = () => img ? `data:${img.mimeType};base64,${img.fileData}` : "";

  // Diagonal container size — guarantees no clipping at any rotation angle
  const nw = naturalSize.w || 800;
  const nh = naturalSize.h || 1100;
  const diagonal = Math.ceil(Math.sqrt(nw * nw + nh * nh) * zoom);
  const imgW = zoom > 1 ? Math.round(nw * zoom) : undefined;
  const imgH = zoom > 1 ? Math.round(nh * zoom) : undefined;

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(15,23,42,0.55)", display: "flex", flexDirection: "column", backdropFilter: "blur(6px)" }}
      onContextMenu={e => e.preventDefault()}
    >
      {/* ── Modal Shell ── */}
      <div style={{ margin: "auto", width: "98vw", height: "96vh", maxWidth: 1400, display: "flex", flexDirection: "column", background: "#f8fafc", borderRadius: 16, overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,0.28), 0 0 0 1px rgba(0,0,0,0.06)" }}>

        {/* ── Top bar ── */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", background: "#fff", flexShrink: 0, borderBottom: "1px solid #e2e8f0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {/* Logo mark */}
            <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, #1e40af, #3b82f6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <LayersIcon style={{ color: "#fff" }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#1e293b", letterSpacing: ".05em", textTransform: "uppercase" }}>All Pages</span>
                <span style={{ background: "#dbeafe", color: "#1d4ed8", fontSize: 10, fontWeight: 700, padding: "1px 7px", borderRadius: 99 }}>{total}</span>
              </div>
              <span style={{ color: "#94a3b8", fontSize: 11, fontWeight: 500 }}>
                {img?.fileName || (allDocs[current] ? `Vol ${allDocs[current].volume_no} · Pg ${allDocs[current].PAGE_NO}` : "")}
              </span>
            </div>
            {loading && <div className="vd-spin" style={{ width: 13, height: 13, border: "2px solid #e2e8f0", borderTopColor: "#3b82f6", borderRadius: "50%", marginLeft: 4 }} />}
          </div>

          {/* Controls */}
          <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
            {/* Zoom group */}
            <div style={{ display: "flex", alignItems: "center", background: "#f1f5f9", borderRadius: 8, padding: "2px", gap: 1, border: "1px solid #e2e8f0" }}>
              <button onClick={() => setZoom(z => Math.max(z - 0.25, 0.25))} disabled={zoom <= 0.25}
                style={{ background: "transparent", border: "none", color: zoom <= 0.25 ? "#cbd5e1" : "#475569", borderRadius: 6, padding: "4px 8px", cursor: zoom <= 0.25 ? "not-allowed" : "pointer", display: "flex", alignItems: "center", transition: "background .15s" }}
                onMouseEnter={e => { if (zoom > 0.25) e.currentTarget.style.background = "#e2e8f0"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
                <ZoomOutIcon />
              </button>
              <span style={{ color: "#1e293b", fontSize: 11, minWidth: 38, textAlign: "center", fontWeight: 700 }}>{Math.round(zoom * 100)}%</span>
              <button onClick={() => setZoom(z => Math.min(z + 0.25, 5))} disabled={zoom >= 5}
                style={{ background: "transparent", border: "none", color: zoom >= 5 ? "#cbd5e1" : "#475569", borderRadius: 6, padding: "4px 8px", cursor: zoom >= 5 ? "not-allowed" : "pointer", display: "flex", alignItems: "center", transition: "background .15s" }}
                onMouseEnter={e => { if (zoom < 5) e.currentTarget.style.background = "#e2e8f0"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
                <ZoomInIcon />
              </button>
            </div>

            {/* Rotate */}
            <button onClick={() => setRotation(r => (r + 90) % 360)}
              style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#475569", borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 12, display: "flex", alignItems: "center", gap: 4, transition: "all .15s" }}
              onMouseEnter={e => { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#1e293b"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#475569"; }}>
              <RotateIcon /><span style={{ fontSize: 11, fontWeight: 600 }}>Rotate</span>
            </button>

            {/* Reset */}
            <button onClick={() => { setZoom(1); setRotation(0); }}
              style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 8, padding: "5px 10px", cursor: "pointer", fontSize: 11, fontWeight: 600, transition: "all .15s" }}
              onMouseEnter={e => { e.currentTarget.style.background = "#e2e8f0"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#f1f5f9"; }}>
              Reset
            </button>

            <div style={{ width: 1, height: 22, background: "#e2e8f0", margin: "0 4px" }} />

            {/* Close */}
            <button onClick={onClose}
              style={{ background: "#fee2e2", border: "1px solid #fecaca", color: "#dc2626", borderRadius: 8, padding: "5px 14px", cursor: "pointer", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 5, transition: "all .15s" }}
              onMouseEnter={e => { e.currentTarget.style.background = "#dc2626"; e.currentTarget.style.color = "#fff"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#fee2e2"; e.currentTarget.style.color = "#dc2626"; }}>
              <CloseIcon /> Close
            </button>
          </div>
        </div>

        {/* ── Body ── */}
        <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

          {/* Sidebar */}
          <div ref={scrollRef} style={{ width: 176, background: "#fff", overflowY: "auto", borderRight: "1px solid #e2e8f0", flexShrink: 0 }}>
            <div style={{ padding: "8px 10px", borderBottom: "1px solid #f1f5f9", background: "#f8fafc" }}>
              <span style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".1em", color: "#94a3b8" }}>Pages</span>
            </div>
            {allDocs.map((doc, idx) => {
              const cached = cache[idx];
              const isActive = idx === current;
              return (
                <div key={idx} data-idx={idx} onClick={() => goTo(idx)}
                  style={{ padding: "9px 12px", cursor: "pointer", borderBottom: "1px solid #f8fafc", background: isActive ? "#eff6ff" : "transparent", borderLeft: isActive ? "3px solid #3b82f6" : "3px solid transparent", transition: "all .12s" }}
                  onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = "#f8fafc"; }}
                  onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = "transparent"; }}>
                  <div style={{ fontSize: 9, color: isActive ? "#3b82f6" : "#94a3b8", marginBottom: 2, fontWeight: 700 }}>{idx + 1} / {total}</div>
                  <div style={{ fontSize: 11, color: isActive ? "#1d4ed8" : "#475569", fontWeight: isActive ? 700 : 400, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {cached?.fileName || `Vol ${doc.volume_no}`}
                  </div>
                  <div style={{ fontSize: 10, color: isActive ? "#60a5fa" : "#cbd5e1", marginTop: 2, fontWeight: 600 }}>
                    Pg {doc.PAGE_NO}
                  </div>
                </div>
              );
            })}
          </div>

          {/* ── Main image area ── */}
          <div
            style={{
              flex: 1,
              overflow: "auto",
              background: "#f1f5f9",
              backgroundSize: "20px 20px",
              display: "flex",
              alignItems: zoom > 1 ? "flex-start" : "center",
              justifyContent: zoom > 1 ? "flex-start" : "center",
              padding: "28px",
              boxSizing: "border-box",
            }}
            onContextMenu={e => e.preventDefault()}
          >
            {loading && !img && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#64748b", fontSize: 13, margin: "auto" }}>
                <div className="vd-spin" style={{ width: 28, height: 28, border: "3px solid #e2e8f0", borderTopColor: "#3b82f6", borderRadius: "50%" }} />
                <span style={{ fontWeight: 600 }}>लोड होत आहे...</span>
              </div>
            )}
            {!loading && !img && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, color: "#94a3b8", fontSize: 13, margin: "auto" }}>
                <div style={{ width: 48, height: 48, borderRadius: 12, background: "#e2e8f0", display: "flex", alignItems: "center", justifyContent: "center" }}><ImageIcon /></div>
                <span>Image उपलब्ध नाही</span>
              </div>
            )}

            {img && (
              <div style={{ margin: "auto", display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
                <div style={{
                  position: "relative",
                  display: "inline-block",
                  lineHeight: 0,
                  transform: `scale(${zoom}) rotate(${rotation}deg)`,
                  transformOrigin: "center center",
                  transition: "transform 0.2s ease",
                  boxShadow: "0 8px 40px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)",
                }}>
                  <img
                    ref={imgRef}
                    src={getUrl()}
                    alt={img.fileName || "document"}
                    onLoad={e => setNaturalSize({ w: e.target.naturalWidth, h: e.target.naturalHeight })}
                    onContextMenu={e => e.preventDefault()}
                    draggable={false}
                    style={{
                      display: "block",
                      maxWidth: zoom <= 1 ? "calc(100vw - 260px)" : "none",
                      maxHeight: zoom <= 1 ? "calc(96vh - 160px)" : "none",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      WebkitUserDrag: "none",
                      pointerEvents: "none",
                      borderRadius: 4,
                    }}
                  />
                  <WatermarkOverlay />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ── Bottom prev/next ── */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 20px", background: "#fff", flexShrink: 0, borderTop: "1px solid #e2e8f0", gap: 16 }}>

          <button onClick={() => goTo(current - 1)} disabled={current === 0 || loading}
            style={{ background: current === 0 || loading ? "#f8fafc" : "#f1f5f9", border: "1px solid #e2e8f0", color: current === 0 || loading ? "#cbd5e1" : "#475569", borderRadius: 8, padding: "7px 20px", cursor: (current === 0 || loading) ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 600, display: "flex", alignItems: "center", gap: 5, transition: "all .15s" }}
            onMouseEnter={e => { if (current !== 0 && !loading) { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#1e293b"; } }}
            onMouseLeave={e => { e.currentTarget.style.background = current === 0 || loading ? "#f8fafc" : "#f1f5f9"; e.currentTarget.style.color = current === 0 || loading ? "#cbd5e1" : "#475569"; }}>
            <ChevronLeft /> Prev
          </button>

          <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, minWidth: 48, textAlign: "center" }}>
            <span style={{ color: "#1d4ed8", fontWeight: 800 }}>{current + 1}</span>
            <span style={{ color: "#cbd5e1" }}> / {total}</span>
          </span>

          <button onClick={() => goTo(current + 1)} disabled={current === total - 1 || loading}
            style={{ background: current === total - 1 || loading ? "#f8fafc" : "#f1f5f9", border: "1px solid #e2e8f0", color: current === total - 1 || loading ? "#cbd5e1" : "#475569", borderRadius: 8, padding: "7px 20px", cursor: (current === total - 1 || loading) ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 600, display: "flex", alignItems: "center", gap: 5, transition: "all .15s" }}
            onMouseEnter={e => { if (current !== total - 1 && !loading) { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#1e293b"; } }}
            onMouseLeave={e => { e.currentTarget.style.background = current === total - 1 || loading ? "#f8fafc" : "#f1f5f9"; e.currentTarget.style.color = current === total - 1 || loading ? "#cbd5e1" : "#475569"; }}>
            Next <ChevronRightNav />
          </button>

        </div>
      </div>
    </div>
  );
}
function InlineImageBlock({ docLoading, docError, docImage, imgError,
  zoom, rotation, setImgError, getDataUrl, handleViewDocument }) {

  if (docLoading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, color: "#475569", fontSize: 13, margin: "auto" }}>
        <div className="vd-spin" style={{ width: 32, height: 32, border: "2px solid #e2e8f0", borderTopColor: "#1d4ed8", borderRadius: "50%" }} />
        Document लोड होत आहे...
      </div>
    );
  }

  if (docError) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, textAlign: "center", padding: 24, margin: "auto" }}>
        <div style={{ width: 48, height: 48, borderRadius: "50%", background: docError === "__404__" ? "#fff7ed" : "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", color: docError === "__404__" ? "#f97316" : "#f87171", fontSize: 22 }}>
          {docError === "__404__" ? "🗂️" : <CloseIcon />}
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: docError === "__404__" ? "#2c1102" : "#ef4444" }}>
          {docError === "__404__" ? "दस्तऐवज उपलब्ध नाही" : "त्रुटी आली"}
        </div>
        <div style={{ fontSize: 12, color: "#94a3b8", maxWidth: 220, lineHeight: 1.6 }}>
          {docError === "__404__" ? "या Volume No. / Page No. साठी कोणताही दस्तऐवज आढळला नाही." : docError}
        </div>
        {docError !== "__404__" && (
          <button onClick={handleViewDocument} style={{ fontSize: 12, color: "#1d4ed8", background: "none", border: "none", cursor: "pointer", textDecoration: "underline" }}>
            पुन्हा प्रयत्न करा
          </button>
        )}
      </div>
    );
  }

  if (docImage && imgError) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, color: "#94a3b8", textAlign: "center", padding: 24, margin: "auto" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#64748b" }}>{docImage.fileName}</div>
        <div style={{ fontSize: 12 }}>हे file browser मध्ये render होऊ शकत नाही.</div>
      </div>
    );
  }

  if (!docImage) return null;

  return (
    <div style={{
      position: "relative",
      display: "inline-block",
      lineHeight: 0,
      transform: `scale(${zoom}) rotate(${rotation}deg)`,
      transformOrigin: "center center",
      transition: "transform 0.2s ease",
    }}>
      <img
        src={getDataUrl()}
        alt={docImage.fileName}
        onLoad={() => setImgError(false)}
        onError={() => setImgError(true)}
        onContextMenu={e => e.preventDefault()}
        draggable={false}
        style={{
          maxHeight: zoom <= 1 ? "calc(100vh - 260px)" : "none",
          maxWidth: zoom <= 1 ? "100%" : "none",
          display: "block",
          userSelect: "none",
          WebkitUserSelect: "none",
          WebkitUserDrag: "none",
          pointerEvents: "none",
        }}
      />
      <WatermarkOverlay />
    </div>
  );
}
const PAGE_SIZE = 16;

// ── Main Component ─────────────────────────────────────────────
export default function ViewDocument({ mode = "private", onStatsChange, onFiltersChange }) {
  const PUBLIC_DOCTYPE = ["अंतिम निवाडा", "निवाडा स्टेटमेंट"];
  const [panels, setPanels] = useState({ filter: true, results: true, detail: true });
  const togglePanel = (name) => {
    setPanels(prev => {
      const next = { ...prev, [name]: !prev[name] };
      return Object.values(next).some(Boolean) ? next : prev;
    });
  };
  const imgRef = useRef(null);
  const [totalCountData, setTotalCountData] = useState([]);
  const [totalCountLoading, setTotalCountLoading] = useState(false);
  const [allTotalCount, setAllTotalCount] = useState('0');
  const [totalCountError, setTotalCountError] = useState(null);
  const [totalCountMeta, setTotalCountMeta] = useState({ totalCount: 0, totalPages: 0, currentPage: 1 });
  const [totalCountFilters, setTotalCountFilters] = useState({});
  const [searched, setSearched] = useState(false);
  const [selectedTotalRow, setSelectedTotalRow] = useState(null);

  const [nvdResults, setNvdResults] = useState([]);
  const [nvdLoading, setNvdLoading] = useState(false);
  const [nvdError, setNvdError] = useState(null);
  const [nvdCurrentPage, setNvdCurrentPage] = useState(1);
  const [nvdTotalCount, setNvdTotalCount] = useState(0);
  const [nvdTotalPages, setNvdTotalPages] = useState(0);
  const [nvdFilters, setNvdFilters] = useState({});
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedDocIndex, setSelectedDocIndex] = useState(-1);

  const [docImage, setDocImage] = useState(null);
  const [docLoading, setDocLoading] = useState(false);
  const [docError, setDocError] = useState(null);
  const [showImages, setShowImages] = useState(true);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [imgError, setImgError] = useState(false);
  const [naturalSize, setNaturalSize] = useState({ w: 0, h: 0 });

  // Modal
  const [showModal, setShowModal] = useState(false);

  const [projects, setProjects] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [docTypeLoading, setDocTypeLoading] = useState(false);
  const [projLoading, setProjLoading] = useState(false);
  const [distLoading, setDistLoading] = useState(false);
  const [talLoading, setTalLoading] = useState(false);
  const [vilLoading, setVilLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [catLoading, setCatLoading] = useState(false);
  const [offices, setOffices] = useState([]);
  const [officeLoading, setOfficeLoading] = useState(false);

  const [form, setForm] = useState({
    project: "", district: "", taluka: "", village: "",
    laqOffice: "", prakaranKkramank: "", yantrana: "", acquiredFor: "",
    docType: "", ownerName: "", category: "",
  });
  const [goToInput, setGoToInput] = useState("");

  useEffect(() => {
    const docTypeParam = mode === "public" ? PUBLIC_DOCTYPE : undefined;
    fetchCategories(docTypeParam ? { docType: docTypeParam } : {});
    fetchProjects();
    fetchAllDistricts();
    fetchAllTalukas();
    fetchAllVillages();
    if (mode !== "public") fetchDocTypes({});
    if (mode === "public") setForm(p => ({ ...p, docType: PUBLIC_DOCTYPE }));
    fetchTotalCount({}, 1);
    setSearched(true);
    fetchOffices({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mode === "public") return;
    const params = {};
    if (form.project) params.projectName = form.project;
    if (form.district) params.district = form.district;
    if (form.taluka) params.tahsil = form.taluka;
    if (form.village) params.village = form.village;
    if (form.category) params.category = form.category;
    fetchDocTypes(params);
    setForm(p => ({ ...p, docType: "" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.project, form.district, form.taluka, form.village, form.category]);

  const fetchCategories = async (params = {}) => {
    setCatLoading(true);
    try {
      const res = await apiService.getNivadaCategory(params);
      setCategories((res?.data || []).map(c => c.project_category).filter(Boolean));
    } catch { setCategories([]); } finally { setCatLoading(false); }
  };
  const fetchOffices = async (params = {}) => {
    setOfficeLoading(true);
    try {
      const qp = { ...params };
      if (mode === "public") qp.docType = PUBLIC_DOCTYPE;
      const res = await apiService.getNivadaOffice(qp);
      setOffices((res?.data || []).map(o => o.Nvd_office).filter(Boolean));
    } catch { setOffices([]); } finally { setOfficeLoading(false); }
  };
  const fetchProjects = async (params = {}) => {
    setProjLoading(true);
    try {
      const qp = { ...params };
      if (mode === "public") qp.docType = PUBLIC_DOCTYPE;
      const res = await apiService.getNivadaProjects(qp);
      setProjects((res?.data || []).map(p => p.nvd_project).filter(Boolean));
    } catch { } finally { setProjLoading(false); }
  };
  const fetchDocTypes = async (params = {}) => {
    setDocTypeLoading(true);
    try {
      const res = await apiService.getNivadaDocType(params);
      setDocTypes((res?.data || []).map(d => d.NVD_doctype).filter(Boolean));
    } catch { setDocTypes([]); } finally { setDocTypeLoading(false); }
  };
  const fetchAllDistricts = async (category = "", village = "", office = "") => {
    setDistLoading(true);
    try {
      const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
      const res = await apiService.getNivadaDistrict(undefined, dt, category || undefined, undefined, village || undefined, office || undefined);
      setDistricts((res?.data || []).map(d => d.district).filter(Boolean));
    } catch { } finally { setDistLoading(false); }
  };
  const fetchAllTalukas = async (category = "", village = "", office = "") => {
    setTalLoading(true);
    try {
      const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
      const res = await apiService.getNivadaTaluka(undefined, village || undefined, undefined, dt, category || undefined, office || undefined);
      setTalukas((res?.data || []).map(t => t.tahsil).filter(Boolean));
    } catch { } finally { setTalLoading(false); }
  };
  const fetchAllVillages = async (category = "", office = "") => {
    setVilLoading(true);
    try {
      const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
      const res = await apiService.getNivadaVillage(undefined, undefined, undefined, dt, category || undefined, office || undefined);
      setVillages((res?.data || []).map(v => v.village).filter(Boolean));
    } catch { } finally { setVilLoading(false); }
  };
  const fetchDistricts = async (project = "", category = "") => {
    setDistLoading(true);
    try {
      const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
      const [distRes, talRes, vilRes] = await Promise.all([
        apiService.getNivadaDistrict(project || undefined, dt, category || undefined),
        apiService.getNivadaTaluka(form.district || undefined, form.village || undefined, project || undefined, dt, category || undefined),
        apiService.getNivadaVillage(form.district || undefined, form.taluka || undefined, project || undefined, dt, category || undefined),
      ]);
      const nd = (distRes?.data || []).map(d => d.district).filter(Boolean);
      const nt = (talRes?.data || []).map(t => t.tahsil).filter(Boolean);
      const nv = (vilRes?.data || []).map(v => v.village).filter(Boolean);
      setDistricts(nd); setTalukas(nt); setVillages(nv);
      setForm(prev => ({ ...prev, district: nd.includes(prev.district) ? prev.district : "", taluka: nt.includes(prev.taluka) ? prev.taluka : "", village: nv.includes(prev.village) ? prev.village : "" }));
    } catch { } finally { setDistLoading(false); }
  };
  const fetchTalukas = async (district, project = "", category = "") => {
    setTalLoading(true);
    try {
      const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
      const [talRes, vilRes] = await Promise.all([
        apiService.getNivadaTaluka(district || undefined, undefined, project || undefined, dt, category || undefined),
        apiService.getNivadaVillage(district || undefined, undefined, project || undefined, dt, category || undefined),
      ]);
      const nt = (talRes?.data || []).map(t => t.tahsil).filter(Boolean);
      const nv = (vilRes?.data || []).map(v => v.village).filter(Boolean);
      setTalukas(nt); setVillages(nv);
      setForm(prev => ({ ...prev, taluka: nt.includes(prev.taluka) ? prev.taluka : "", village: nv.includes(prev.village) ? prev.village : "" }));
    } catch { } finally { setTalLoading(false); }
  };
  const fetchVillages = async (district, taluka, project = "", category = "") => {
    setVilLoading(true);
    try {
      const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
      const res = await apiService.getNivadaVillage(district || undefined, taluka || undefined, project || undefined, dt, category || undefined);
      const nv = (res?.data || []).map(v => v.village).filter(Boolean);
      setVillages(nv);
      setForm(prev => ({ ...prev, village: nv.includes(prev.village) ? prev.village : "" }));
    } catch { } finally { setVilLoading(false); }
  };

  const fetchTotalCount = async (params = {}, page = 1) => {
    setTotalCountLoading(true); setTotalCountError(null); setTotalCountData([]);
    setSelectedDoc(null); setSelectedTotalRow(null);
    setNvdResults([]); setNvdError(null);
    setShowImages(false); setDocImage(null);
    setAllDocStubs([]); // reset stubs on new search
    try {
      const totalParams = { ...params, page, pageSize: PAGE_SIZE };
      if (mode === "public") totalParams.docType = PUBLIC_DOCTYPE;
      const res = await apiService.getNivadaTotalCount(totalParams);
      setTotalCountData(res?.data || []);
      setAllTotalCount(res?.totalAllCount || 0);
      setTotalCountMeta({ totalCount: res?.totalCount || 0, totalPages: res?.totalPages || 0, currentPage: res?.page || page });
      onStatsChange?.({ allTotalCount: res?.totalAllCount || 0, totalCount: res?.totalCount || 0 });
      setSearched(true);
    } catch { setTotalCountError("माहिती लोड करताना त्रुटी आली."); }
    finally { setTotalCountLoading(false); }
  };

  const fetchNivadaPage = async (params = {}, page = 1, pickLast = false) => {
    setNvdLoading(true); setNvdError(null);
    setSelectedDoc(null); setShowImages(false); setDocImage(null); setDocError(null);
    setAllDocStubs([]); // reset stubs for new prakaran
    try {
      const res = await apiService.getNivada({ pageSize: PAGE_SIZE, ...params, page });
      const data = res?.data || [];
      setNvdResults(data);
      setNvdTotalCount(res?.totalCount || 0);
      setNvdTotalPages(res?.totalPages || 0);
      setNvdCurrentPage(res?.page || page);
      if (data.length > 0) {
        const idx = pickLast ? data.length - 1 : 0;
        const doc = data[idx];
        setSelectedDoc(doc); setSelectedDocIndex(idx);
        setPanels(p => ({ ...p, detail: true }));
        setShowImages(true);
        loadDocImage(doc);
      }
    } catch { setNvdError("Documents लोड करताना त्रुटी आली."); }
    finally { setNvdLoading(false); }
  };

  const handleTotalRowClick = (row) => {
    setSelectedTotalRow(row);
    const params = {
      prakaranKkramank: row.NVD_Prakaran_kramank || "null",
      ...(row.NVD_doctype && { docType: row.NVD_doctype }),
      ...(row.master_project_name && { projectName: row.master_project_name }),
      ...(row.district && { district: row.district }),
      ...(row.tahsil && { taluka: row.tahsil }),
      ...(row.village && { village: row.village }),
      ...(row.Nvd_office && { office: row.Nvd_office }),
    };
    setNvdFilters(params);
    fetchNivadaPage(params, 1, false);
  };

  const globalDocIndex = selectedDocIndex >= 0 ? (nvdCurrentPage - 1) * PAGE_SIZE + selectedDocIndex : -1;
  const hasPrev = globalDocIndex > 0;
  const hasNext = globalDocIndex >= 0 && globalDocIndex < nvdTotalCount - 1;

  const openDoc = (doc, idx) => {
    setSelectedDoc(doc); setSelectedDocIndex(idx);
    setDocImage(null); setDocError(null);
    setImgError(false); setZoom(1); setRotation(0); setNaturalSize({ w: 0, h: 0 });
    if (showImages) loadDocImage(doc);
  };

  const handlePrevDoc = async () => {
    if (!hasPrev) return;
    if (selectedDocIndex > 0) { openDoc(nvdResults[selectedDocIndex - 1], selectedDocIndex - 1); }
    else {
      setNvdLoading(true);
      try {
        const res = await apiService.getNivada({ pageSize: PAGE_SIZE, page: nvdCurrentPage - 1, ...nvdFilters });
        const data = res?.data || [];
        setNvdResults(data); setNvdCurrentPage(res?.page || nvdCurrentPage - 1);
        setNvdTotalCount(res?.totalCount || 0); setNvdTotalPages(res?.totalPages || 0);
        if (data.length) openDoc(data[data.length - 1], data.length - 1);
      } catch { setNvdError("Documents लोड करताना त्रुटी आली."); } finally { setNvdLoading(false); }
    }
  };

  const handleNextDoc = async () => {
    if (!hasNext) return;
    if (selectedDocIndex < nvdResults.length - 1) { openDoc(nvdResults[selectedDocIndex + 1], selectedDocIndex + 1); }
    else {
      setNvdLoading(true);
      try {
        const res = await apiService.getNivada({ pageSize: PAGE_SIZE, page: nvdCurrentPage + 1, ...nvdFilters });
        const data = res?.data || [];
        setNvdResults(data); setNvdCurrentPage(res?.page || nvdCurrentPage + 1);
        setNvdTotalCount(res?.totalCount || 0); setNvdTotalPages(res?.totalPages || 0);
        if (data.length) openDoc(data[0], 0);
      } catch { setNvdError("Documents लोड करताना त्रुटी आली."); } finally { setNvdLoading(false); }
    }
  };

  const handleGoToDoc = async (targetGlobal) => {
    if (targetGlobal < 1 || targetGlobal > nvdTotalCount) return;
    const targetPage = Math.ceil(targetGlobal / PAGE_SIZE);
    const targetIdx = (targetGlobal - 1) % PAGE_SIZE;
    if (targetPage === nvdCurrentPage) { openDoc(nvdResults[targetIdx], targetIdx); }
    else {
      setNvdLoading(true);
      try {
        const res = await apiService.getNivada({ pageSize: PAGE_SIZE, page: targetPage, ...nvdFilters });
        const data = res?.data || [];
        setNvdResults(data); setNvdCurrentPage(res?.page || targetPage);
        setNvdTotalCount(res?.totalCount || 0); setNvdTotalPages(res?.totalPages || 0);
        if (data[targetIdx]) openDoc(data[targetIdx], targetIdx);
      } catch { setNvdError("Documents लोड करताना त्रुटी आली."); } finally { setNvdLoading(false); }
    }
  };

  const handleViewDocument = () => loadDocImage(selectedDoc);

  const loadDocImage = async (doc) => {
    if (!doc?.volume_no || !doc?.PAGE_NO) return;
    setDocImage(null); setDocError(null); setImgError(false); setZoom(1); setRotation(0); setNaturalSize({ w: 0, h: 0 });
    setShowImages(true); setDocLoading(true);
    try {
      const res = await apiService.getNivadaDocument(doc.volume_no, doc.PAGE_NO);
      const raw = res?.data ?? res;
      if (!raw?.fileData) { setDocError("या page साठी कोणतेही image आढळले नाही."); return; }
      const docImageObj = {
        fileName: raw.fileName ?? `${raw.volumnNo}_page_${raw.pageNo}.jpg`,
        mimeType: raw.mimeType ?? "image/jpeg",
        fileData: raw.fileData.replace(/[\s\r\n]+/g, ""),
        pageNo: raw.pageNo ?? doc.PAGE_NO,
        volumnNo: raw.volumnNo ?? doc.volume_no,
      };
      setDocImage(docImageObj);
    } catch (err) {
      const is404 = err?.response?.status === 404 || err?.status === 404 || (err?.message && err.message.includes("404"));
      setDocError(is404 ? "__404__" : "Document लोड करताना त्रुटी आली: " + err.message);
    } finally { setDocLoading(false); }
  };

  const handleCloseImages = () => { setShowImages(false); setDocImage(null); setDocError(null); setImgError(false); setZoom(1); setRotation(0); setNaturalSize({ w: 0, h: 0 }); };
  const handleZoomIn = () => setZoom(z => Math.min(z + 0.25, 5));
  const handleZoomOut = () => setZoom(z => Math.max(z - 0.25, 0.25));
  const handleRotate = () => setRotation(r => (r + 90) % 360);
  const handleResetView = () => { setZoom(1); setRotation(0); setNaturalSize({ w: 0, h: 0 }); };
  const getDataUrl = () => docImage ? `data:${docImage.mimeType};base64,${docImage.fileData}` : "";

  // ── fetchImageForModal: used by ImageListModal for lazy loading ──
  const fetchImageForModal = async (volume_no, PAGE_NO) => {
    const res = await apiService.getNivadaDocument(volume_no, PAGE_NO);
    const raw = res?.data ?? res;
    if (!raw?.fileData) return null;
    return {
      fileName: raw.fileName ?? `${raw.volumnNo}_page_${raw.pageNo}.jpg`,
      mimeType: raw.mimeType ?? "image/jpeg",
      fileData: raw.fileData.replace(/[\s\r\n]+/g, ""),
      pageNo: raw.pageNo ?? PAGE_NO,
      volumnNo: raw.volumnNo ?? volume_no,
    };
  };

  // ── Open All Pages modal ──
  // Collect all doc stubs from ALL pages of nvd results, then open modal instantly.
  // Modal itself will lazy-fetch images on next/prev.
  const [allDocStubs, setAllDocStubs] = useState([]);
  const [allPagesLoading, setAllPagesLoading] = useState(false);
  const [allPagesProgress, setAllPagesProgress] = useState(0);

  const handleOpenAllPages = async () => {
    if (!selectedDoc || !docImage) return;

    // If we already have stubs for this prakaran, open immediately
    if (allDocStubs.length > 0) {
      const idx = allDocStubs.findIndex(d => d.volume_no === selectedDoc.volume_no && d.PAGE_NO === selectedDoc.PAGE_NO);
      setShowModal(true);
      return;
    }

    // Fetch all doc stubs (just records, no images)
    setAllPagesLoading(true);
    setAllPagesProgress(0);
    try {
      const stubs = [];
      const totalP = nvdTotalPages || 1;
      for (let p = 1; p <= totalP; p++) {
        const res = await apiService.getNivada({ pageSize: PAGE_SIZE, page: p, ...nvdFilters });
        stubs.push(...(res?.data || []));
        setAllPagesProgress(Math.round((p / totalP) * 100));
      }
      setAllDocStubs(stubs);
      setShowModal(true);
    } catch (e) {
      console.error("All pages stubs error", e);
    } finally {
      setAllPagesLoading(false);
      setAllPagesProgress(0);
    }
  };

  const handleCategoryChange = (value) => {
    setForm(p => ({ ...p, category: value, project: "", district: "", taluka: "", village: "", docType: "" }));
    const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
    fetchProjects({ ...(value && { category: value }), ...(dt && { docType: dt }) });
    fetchAllDistricts(value); fetchAllTalukas(value); fetchAllVillages(value);
    if (mode !== "public") fetchDocTypes({ ...(value && { category: value }) });
    fetchOffices({ ...(value && { category: value }) });
  };
  const handleProjectChange = (v) => {
    setForm(p => ({ ...p, project: v }));
    fetchDistricts(v, form.category);
    if (mode !== "public") fetchDocTypes({ ...(v && { projectName: v }), ...(form.category && { category: form.category }) });
    fetchOffices({ ...(v && { projectName: v }), ...(form.category && { category: form.category }) });
  };
  const handleDistrictChange = (v) => {
    setForm(p => ({ ...p, district: v, taluka: "", village: "" }));
    const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
    fetchTalukas(v, form.project, form.category);
    fetchProjects({ ...(v && { district: v }), ...(form.category && { category: form.category }), ...(dt && { docType: dt }) });
    fetchCategories({ ...(v && { district: v }), ...(dt && { docType: dt }) });
    if (mode !== "public") fetchDocTypes({ ...(v && { district: v }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
    fetchOffices({ ...(v && { district: v }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
  };
  const handleTalukaChange = (v) => {
    setForm(p => ({ ...p, taluka: v, village: "" }));
    const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
    fetchVillages(form.district, v, form.project, form.category);
    fetchProjects({ ...(v && { tahsil: v }), ...(form.district && { district: form.district }), ...(form.category && { category: form.category }), ...(dt && { docType: dt }) });
    fetchCategories({ ...(v && { tahsil: v }), ...(form.district && { district: form.district }), ...(dt && { docType: dt }) });
    if (mode !== "public") fetchDocTypes({ ...(v && { tahsil: v }), ...(form.district && { district: form.district }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
    fetchOffices({ ...(v && { tahsil: v }), ...(form.district && { district: form.district }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
  };
  const handleVillageChange = (v) => {
    setForm(p => ({ ...p, village: v }));
    const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
    fetchProjects({ ...(v && { village: v }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(form.category && { category: form.category }), ...(dt && { docType: dt }) });
    fetchAllDistricts(form.category, v); fetchAllTalukas(form.category, v);
    fetchCategories({ ...(v && { village: v }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(dt && { docType: dt }) });
    if (mode !== "public") fetchDocTypes({ ...(v && { village: v }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
    fetchOffices({ ...(v && { village: v }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
  };
  const handleOfficeChange = (v) => {
    setForm(p => ({ ...p, laqOffice: v }));
    const dt = mode === "public" ? PUBLIC_DOCTYPE : undefined;
    fetchProjects({ ...(v && { office: v }), ...(form.category && { category: form.category }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(form.village && { village: form.village }), ...(dt && { docType: dt }) });
    fetchAllDistricts(form.category, form.village, v);
    fetchAllTalukas(form.category, form.village, v);
    fetchAllVillages(form.category, v);
    fetchCategories({ ...(v && { office: v }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(dt && { docType: dt }) });
    if (mode !== "public") fetchDocTypes({ ...(v && { office: v }), ...(form.district && { district: form.district }), ...(form.taluka && { tahsil: form.taluka }), ...(form.village && { village: form.village }), ...(form.category && { category: form.category }), ...(form.project && { projectName: form.project }) });
  };
  const handleChange = (f, v) => setForm(p => ({ ...p, [f]: v }));

  const buildFilters = () => ({
    ...(form.project && { projectName: form.project }),
    ...(form.district && { district: form.district }),
    ...(form.taluka && { tahsil: form.taluka }),
    ...(form.village && { village: form.village }),
    ...(form.laqOffice && { office: form.laqOffice }),
    ...(form.prakaranKkramank && { prakaranKkramank: form.prakaranKkramank }),
    ...(form.yantrana && { yantrana: form.yantrana }),
    ...(form.acquiredFor && { acquiredFor: form.acquiredFor }),
    ...(form.category && { category: form.category }),
    ...(form.ownerName && form.ownerName.trim() && { ownerName: form.ownerName.trim() }),
    docType: mode === "public" ? PUBLIC_DOCTYPE : (form.docType || undefined),
  });

  const handleSearch = () => {
    const f = buildFilters();
    setTotalCountFilters(f);
    fetchTotalCount(f, 1);
    setPanels(p => ({ ...p, results: true }));
    onFiltersChange?.(form);
  };
  const handleTotalCountPageChange = (page) => fetchTotalCount(totalCountFilters, page);

  const handleReset = () => {
    setTotalCountFilters({}); setTotalCountData([]); setTotalCountError(null);
    setTotalCountMeta({ totalCount: 0, totalPages: 0, currentPage: 1 });
    setSearched(false); setSelectedTotalRow(null);
    setSelectedDoc(null); setNvdResults([]); setNvdFilters({});
    setShowImages(false); setDocImage(null); setDocTypes([]);

    const base = { project: "", district: "", taluka: "", village: "", laqOffice: "", prakaranKkramank: "", yantrana: "", acquiredFor: "", docType: "", ownerName: "", category: "" };
    const docTypeParam = mode === "public" ? { docType: PUBLIC_DOCTYPE } : {};
    if (mode === "public") { setForm({ ...base, docType: PUBLIC_DOCTYPE }); fetchProjects(docTypeParam); }
    else { setForm(base); fetchProjects(); fetchDocTypes({}); }
    fetchCategories(docTypeParam);
    fetchAllDistricts(); fetchAllTalukas(); fetchAllVillages();
    fetchTotalCount({}, 1);
    setSearched(true);
    fetchOffices({});
    onFiltersChange?.({});
  };

  const isFormEmpty = !form.category && !form.project && !form.district && !form.taluka && !form.village &&
    !form.laqOffice && !form.prakaranKkramank && !form.yantrana && !form.acquiredFor &&
    !form.ownerName && !(mode !== "public" && form.docType);

  const sel = "w-full text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg py-1.5 pl-3 pr-8 outline-none transition-all vd-sel";
  const inp = "w-full text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg py-1.5 px-3 outline-none transition-all vd-inp";
  const pHdr = { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 10px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", flexShrink: 0 };
  const pHdrL = { display: "flex", alignItems: "center", gap: 6 };
  const pHdrTitle = { fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: ".07em" };

  // ── Inline image: for 100% zoom, fit-to-panel; for >100%, scroll ──
  const is90 = rotation === 90 || rotation === 270;
  const containerPadInline = is90 && naturalSize.w > 0
    ? Math.max(0, (naturalSize.w - naturalSize.h) / 2) * zoom
    : 0;

  return (
    <>
      {showModal && allDocStubs.length > 0 && docImage && (
        <ImageListModal
          allDocs={allDocStubs}
          initialDocIdx={Math.max(0, allDocStubs.findIndex(d => d.volume_no === selectedDoc?.volume_no && d.PAGE_NO === selectedDoc?.PAGE_NO))}
          initialImg={docImage}
          fetchImage={fetchImageForModal}
          onClose={() => setShowModal(false)}
        />
      )}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
        @keyframes vd-spin { to { transform: rotate(360deg); } }
        .vd-spin { animation: vd-spin 0.7s linear infinite; }
        .vd-scroll::-webkit-scrollbar { width: 5px; }
        .vd-scroll::-webkit-scrollbar-track { background: #f1f5f9; }
        .vd-scroll::-webkit-scrollbar-thumb { background: #c7d4e4; border-radius: 3px; }
        .vd-sel { appearance:none; -webkit-appearance:none; }
        .vd-sel:focus, .vd-inp:focus { border-color:#1a4480; box-shadow:0 0 0 3px rgba(26,68,128,.1); background:#fff; }
        .vd-sel:disabled { opacity:.5; cursor:not-allowed; }
        .vd-inp::placeholder { color:#c0ccd8; }
        .vd-table-row:hover td { background:#f0f7ff; cursor:pointer; }
        .vd-total-row:hover td { background:#f0f7ff !important; }
        .vd-search-btn:hover:not(:disabled) { background:#1a4480 !important; }
        .vd-reset-btn:hover { background:#f0f4f8 !important; }
        .vd-page-btn:hover { background:#eff6ff !important; border-color:#93c5fd !important; color:#1d4ed8 !important; }
        .vd-doc-btn:hover:not(:disabled) { background:#1d4ed8 !important; }
        .vd-img-ctrl:hover:not(:disabled) { background:#e0e7ef !important; }
        .vd-img-ctrl:disabled { opacity:.35; cursor:not-allowed; }
        .vd-close-btn-sm:hover { background:#f1f5f9 !important; }
        .vd-section-hdr:hover { background:#f1f4f8 !important; }
        .vd-collapsed-tab:hover { background:#f8fafc !important; }
        .vd-toggle-btn:hover { background:#e2e8f0 !important; }
        .vd-owner-row:hover { background:#f0f7ff; }
        .vd-nav-btn:hover:not(:disabled) { background:#eff6ff !important; border-color:#bfdbfe !important; color:#1d4ed8 !important; }
        .vd-nav-btn:disabled { opacity:.4 !important; cursor:not-allowed !important; }
        .vd-modal-ctrl:hover { background:#334155 !important; }
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>

      <div style={{ background: "#f1f5f9", fontFamily: "'DM Sans','Noto Sans Devanagari',sans-serif", border: "1px solid #e2e8f0", borderRadius: "10px" }}>
        <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 120px)", overflow: "hidden" }}>

          {/* ═══ PANEL 1 — Filters ═══ */}
          {panels.filter ? (
            <div style={{ background: "#fff", borderBottom: "1px solid #e2e8f0", flexShrink: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 10px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ color: "#64748b" }}><FilterIcon /></span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: ".07em" }}>Filters</span>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="vd-search-btn" onClick={handleSearch} disabled={totalCountLoading || isFormEmpty}
                    style={{ display: "flex", alignItems: "center", gap: 6, background: "#1f3a66", color: "#fff", fontSize: 12, fontWeight: 600, padding: "5px 14px", border: "none", borderRadius: 6, cursor: (totalCountLoading || isFormEmpty) ? "not-allowed" : "pointer", opacity: (totalCountLoading || isFormEmpty) ? 0.7 : 1 }}>
                    <SearchIcon />{totalCountLoading ? "Loading..." : "Search"}
                  </button>
                  <button className="vd-reset-btn" onClick={handleReset}
                    style={{ display: "flex", alignItems: "center", gap: 5, background: "transparent", border: "1px solid #e2e8f0", color: "#64748b", fontSize: 12, fontWeight: 500, padding: "5px 10px", borderRadius: 6, cursor: "pointer" }}>
                    <CloseIcon />Reset
                  </button>
                  <button onClick={() => togglePanel("filter")} className="vd-toggle-btn"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 24, height: 24, borderRadius: 4, border: "none", background: "transparent", cursor: "pointer", color: "#94a3b8", padding: 0 }}>
                    <ChevronDown />
                  </button>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", padding: "4px 12px", fontSize: 10, fontWeight: 600, color: "#64748b", background: "#e1edf9", borderBottom: "1px solid #e2e8f0", letterSpacing: ".06em" }}>
                Select <b style={{ margin: "0 3px" }}>All</b> or <b style={{ margin: "0 3px" }}>Any</b> option to apply filters
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 10, padding: "8px 12px" }}>
                {[
                  { label: "District", value: form.district, opts: districts, loading: distLoading, onChange: handleDistrictChange, ph: "-- District --" },
                  { label: "Taluka", value: form.taluka, opts: talukas, loading: talLoading, onChange: handleTalukaChange, ph: "-- Taluka --" },
                  { label: "Village", value: form.village, opts: villages, loading: vilLoading, onChange: handleVillageChange, ph: "-- Village --" },
                  { label: "Category", value: form.category, opts: categories, loading: catLoading, onChange: handleCategoryChange, ph: "-- Category --" },
                  { label: "Project", value: form.project, opts: projects, loading: projLoading, onChange: handleProjectChange, ph: "-- Project --" },
                  ...(mode !== "public" ? [{ label: "Doc Type", value: form.docType, opts: docTypes.map(d => ({ v: d, l: d.replace(/^\d+\.\s*/, "") })), loading: docTypeLoading, onChange: v => handleChange("docType", v), ph: "-- Doc Type --", isDocType: true }] : []),
                  { label: "LAQ Office", value: form.laqOffice, opts: offices, loading: officeLoading, onChange: handleOfficeChange, ph: "-- Office --" },
                ].map(({ label, value, opts, loading, onChange, ph, isDocType }) => (
                  <div key={label} style={{ minWidth: 130, flexShrink: 0 }}>
                    <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 3 }}>{label}</label>
                    <div style={{ position: "relative" }}>
                      <select className={sel} value={value} onChange={e => onChange(e.target.value)} disabled={loading}>
                        <option value="">{ph}</option>
                        {isDocType
                          ? opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)
                          : opts.map(v => <option key={v} value={v}>{v}</option>)}
                      </select>
                      <span style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: "#94a3b8" }}><ChevronDown /></span>
                    </div>
                  </div>
                ))}
                {[
                  { label: "Prakaran Kramank", field: "prakaranKkramank", ph: "e.g. 07/1988-1989" },
                  { label: "Yantrana", field: "yantrana", ph: "Enter yantrana" },
                  { label: "Acquired For", field: "acquiredFor", ph: "Enter purpose" },
                ].map(({ label, field, ph }) => (
                  <div key={field} style={{ minWidth: 130, flexShrink: 0 }}>
                    <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 3 }}>{label}</label>
                    <input className={inp} placeholder={ph} value={form[field]} onChange={e => handleChange(field, e.target.value)} />
                  </div>
                ))}
                <div style={{ minWidth: 150, flexShrink: 0 }}>
                  <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 3 }}>Owner Name</label>
                  <div style={{ position: "relative" }}>
                    <input className={inp} placeholder="मालकाचे नाव..." value={form.ownerName}
                      onChange={e => handleChange("ownerName", e.target.value)}
                      onKeyDown={e => { if (e.key === "Enter") handleSearch(); }} />
                    {form.ownerName && (
                      <button onClick={() => handleChange("ownerName", "")} style={{ position: "absolute", right: 7, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 0 }}>
                        <CloseIcon />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div onClick={() => togglePanel("filter")} className="vd-collapsed-tab"
              style={{ height: 28, flexShrink: 0, background: "#fff", borderBottom: "1px solid #e2e8f0", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", paddingLeft: 14, cursor: "pointer", userSelect: "none", gap: 8 }}>
              <span style={{ color: "#94a3b8" }}><FilterIcon /></span>
              <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#94a3b8" }}>Filters</span>
            </div>
          )}

          {/* ═══ PANELS 2 + 3 ═══ */}
          <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>

            {/* Panel 2 — Results */}
            {panels.results ? (
              <div style={{ flex: "0 0 50%", minWidth: 240, borderRight: "1px solid #e2e8f0", background: "#fff", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div style={pHdr}>
                  <div style={pHdrL}>
                    <span style={{ color: "#64748b" }}><TableIcon /></span>
                    <span style={pHdrTitle}>Results</span>
                    {searched && totalCountMeta.totalCount > 0 && (
                      <span style={{ background: "#eff6ff", color: "#1d4ed8", fontSize: 10, fontWeight: 700, padding: "1px 7px", borderRadius: 99 }}>{totalCountMeta.totalCount.toLocaleString()}</span>
                    )}
                  </div>
                  <button onClick={() => togglePanel("results")} className="vd-toggle-btn"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 20, height: 20, borderRadius: 4, border: "none", background: "transparent", cursor: "pointer", color: "#94a3b8", padding: 0 }}>
                    <ChevronLeft />
                  </button>
                </div>
                {!searched ? (
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, padding: "40px 20px", color: "#94a3b8" }}>
                    <div style={{ width: 52, height: 52, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#eff6ff,#dbeafe)", color: "#1d4ed8" }}><FilterIcon /></div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#64748b" }}>Search to begin</div>
                    <div style={{ fontSize: 12, textAlign: "center", maxWidth: 200, lineHeight: 1.5 }}>Filter criteria वापरून दस्तऐवज शोधा</div>
                  </div>
                ) : (
                  <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                    <TotalCountTable data={totalCountData} loading={totalCountLoading} error={totalCountError}
                      totalCount={totalCountMeta.totalCount} totalPages={totalCountMeta.totalPages} currentPage={totalCountMeta.currentPage}
                      selectedRow={selectedTotalRow} onRowClick={handleTotalRowClick} onPageChange={handleTotalCountPageChange} mode={mode} pageSize={PAGE_SIZE} />
                  </div>
                )}
              </div>
            ) : (
              <CollapsedTab label="Results" icon={<TableIcon />} onClick={() => togglePanel("results")} />
            )}

            {/* Panel 3 — Detail */}
            {panels.detail ? (
              <div style={{ flex: "1 1 0", background: "#f8fafc", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div style={pHdr}>
                  <div style={pHdrL}>
                    <span style={{ color: "#64748b" }}><InfoIcon /></span>
                    {selectedDoc
                      ? <><span style={pHdrTitle}>Detail —</span><span style={{ fontSize: 12, fontWeight: 700, color: "#1d4ed8" }}>{selectedDoc.NVD_Prakaran_kramank || `ID: ${selectedDoc.id}`}</span></>
                      : <span style={pHdrTitle}>Detail</span>}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    {selectedDoc && (
                      <>
                        <button className="vd-doc-btn"
                          onClick={() => {
                            if (!showImages) { setShowImages(true); if (!docImage && !docLoading) loadDocImage(selectedDoc); }
                            else { setShowImages(false); }
                          }}
                          style={{ display: "flex", alignItems: "center", gap: 5, background: "#1d4ed8", color: "#fff", fontSize: 11, fontWeight: 600, padding: "4px 10px", border: "none", borderRadius: 6, cursor: "pointer", transition: "background .15s" }}>
                          {showImages ? <><InfoIcon />View Owner</> : <><ImageIcon />View Document</>}
                        </button>
                        <button className="vd-close-btn-sm" onClick={() => { setSelectedDoc(null); handleCloseImages(); }}
                          style={{ display: "flex", alignItems: "center", gap: 4, background: "transparent", border: "1px solid #e2e8f0", color: "#64748b", fontSize: 11, padding: "4px 8px", borderRadius: 6, cursor: "pointer", transition: "background .15s" }}>
                          <CloseIcon />Close
                        </button>
                      </>
                    )}
                    <button onClick={() => togglePanel("detail")} className="vd-toggle-btn"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 20, height: 20, borderRadius: 4, border: "none", background: "transparent", cursor: "pointer", color: "#94a3b8", padding: 0 }}>
                      <ChevronLeft />
                    </button>
                  </div>
                </div>

                {nvdLoading && !selectedDoc && (
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, color: "#64748b", fontSize: 13 }}>
                    <div className="vd-spin" style={{ width: 28, height: 28, border: "2px solid #e2e8f0", borderTopColor: "#1d4ed8", borderRadius: "50%" }} />
                    Documents लोड होत आहे...
                  </div>
                )}
                {nvdError && !nvdLoading && (
                  <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 24, color: "#ef4444", fontSize: 13 }}>{nvdError}</div>
                )}
                {!nvdLoading && !nvdError && !selectedDoc && (
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#94a3b8" }}>
                    <div style={{ width: 52, height: 52, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#eff6ff,#dbeafe)", color: "#1d4ed8" }}><DocIcon /></div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#64748b" }}>{selectedTotalRow ? "कोणताही document आढळला नाही" : "Select a row to view details"}</div>
                    <div style={{ fontSize: 12 }}>{selectedTotalRow ? "या Prakaran / DocType साठी records नाहीत" : "Results panel मधून एक row निवडा"}</div>
                  </div>
                )}

                {selectedDoc && (
                  showImages ? (
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                      {/* Image toolbar */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 12px", borderBottom: "1px solid #e2e8f0", background: "#fff", flexShrink: 0, flexWrap: "wrap", gap: 6 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".07em", color: "#64748b", display: "flex", alignItems: "center", gap: 5 }}>
                            <ImageIcon />Document Image
                          </span>
                          <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <button className="vd-nav-btn" onClick={handlePrevDoc} disabled={!hasPrev || nvdLoading}
                              style={{ display: "flex", alignItems: "center", gap: 3, background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 4, padding: "3px 8px", fontSize: 11, fontWeight: 600, cursor: "pointer", color: "#475569", transition: "all .15s" }}>
                              <ChevronLeft /><span>Prev</span>
                            </button>
                            {globalDocIndex >= 0 && (
                              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                <input type="number" min={1} max={nvdTotalCount}
                                  value={goToInput !== "" ? goToInput : globalDocIndex + 1}
                                  onChange={e => setGoToInput(e.target.value)}
                                  onFocus={() => setGoToInput(String(globalDocIndex + 1))}
                                  onKeyDown={e => {
                                    if (e.key === "Enter") { const v = parseInt(goToInput); if (!isNaN(v) && v >= 1 && v <= nvdTotalCount) handleGoToDoc(v); setGoToInput(""); }
                                    if (e.key === "Escape") setGoToInput("");
                                  }}
                                  onBlur={() => setGoToInput("")}
                                  style={{ width: 44, textAlign: "center", fontSize: 11, fontWeight: 700, color: "#1d4ed8", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 4, padding: "2px 4px", outline: "none" }} />
                                <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600 }}>/ {nvdTotalCount}</span>
                              </div>
                            )}
                            <button className="vd-nav-btn" onClick={handleNextDoc} disabled={!hasNext || nvdLoading}
                              style={{ display: "flex", alignItems: "center", gap: 3, background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 4, padding: "3px 8px", fontSize: 11, fontWeight: 600, cursor: "pointer", color: "#475569", transition: "all .15s" }}>
                              <span>Next</span><ChevronRightNav />
                            </button>
                          </div>
                        </div>
                        {docImage && !docLoading && !docError && !imgError && (
                          <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                            <button className="vd-img-ctrl" onClick={handleZoomOut} disabled={zoom <= 0.25}
                              style={{ display: "flex", alignItems: "center", gap: 3, background: "#f1f5f9", border: "none", borderRadius: 4, padding: "3px 7px", fontSize: 11, fontWeight: 500, cursor: "pointer", color: "#475569" }}>
                              <ZoomOutIcon /><span style={{ fontSize: 10 }}>{Math.round(zoom * 100)}%</span>
                            </button>
                            <button className="vd-img-ctrl" onClick={handleZoomIn} disabled={zoom >= 5}
                              style={{ display: "flex", alignItems: "center", gap: 3, background: "#f1f5f9", border: "none", borderRadius: 4, padding: "3px 7px", fontSize: 11, cursor: "pointer", color: "#475569" }}>
                              <ZoomInIcon />
                            </button>
                            <button className="vd-img-ctrl" onClick={handleRotate}
                              style={{ display: "flex", alignItems: "center", gap: 3, background: "#f1f5f9", border: "none", borderRadius: 4, padding: "3px 7px", fontSize: 11, cursor: "pointer", color: "#475569" }}>
                              <RotateIcon />
                            </button>
                            <button className="vd-img-ctrl" onClick={handleResetView}
                              style={{ background: "#f1f5f9", border: "none", borderRadius: 4, padding: "3px 7px", fontSize: 11, cursor: "pointer", color: "#64748b" }}>Reset</button>
                            <button onClick={handleOpenAllPages} disabled={allPagesLoading || !docImage}
                              style={{ display: "flex", alignItems: "center", gap: 4, background: "#1e293b", border: "none", color: "#e2e8f0", borderRadius: 4, padding: "3px 9px", fontSize: 11, cursor: (allPagesLoading || !docImage) ? "not-allowed" : "pointer", opacity: !docImage ? 0.5 : 1, minWidth: 80, justifyContent: "center" }}>
                              {allPagesLoading ? (
                                <><div className="vd-spin" style={{ width: 10, height: 10, border: "2px solid #334155", borderTopColor: "#93c5fd", borderRadius: "50%", flexShrink: 0 }} /><span>{allPagesProgress}%</span></>
                              ) : (
                                <><LayersIcon /><span>All Pages ({nvdTotalCount})</span></>
                              )}
                            </button>
                          </div>
                        )}
                        <button className="vd-close-btn-sm" onClick={handleCloseImages}
                          style={{ background: "transparent", border: "none", cursor: "pointer", color: "#94a3b8", padding: 4, borderRadius: 4 }}>
                          <CloseIcon />
                        </button>
                      </div>

                      {/* ── Image display area ── */}
                      <div
                        style={{
                          flex: 1,
                          overflow: "auto",
                          background: "#cbd5e1",
                          minHeight: 0,
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          padding: "20px",
                          boxSizing: "border-box",
                        }}
                        onContextMenu={e => e.preventDefault()}
                      >
                        <InlineImageBlock
                          docLoading={docLoading}
                          docError={docError}
                          docImage={docImage}
                          imgError={imgError}
                          zoom={zoom}
                          rotation={rotation}
                          naturalSize={naturalSize}
                          setNaturalSize={setNaturalSize}
                          setImgError={setImgError}
                          getDataUrl={getDataUrl}
                          handleViewDocument={handleViewDocument}
                          imgRef={imgRef}
                        />
                      </div>
                    </div>
                  ) : (
                    /* Detail Card */
                    <div className="vd-scroll" style={{ flex: 1, overflowY: "auto", padding: 16 }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 14px" }}>
                        <button className="vd-nav-btn" onClick={handlePrevDoc} disabled={!hasPrev || nvdLoading}
                          style={{ display: "flex", alignItems: "center", gap: 4, background: hasPrev && !nvdLoading ? "#f1f5f9" : "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 5, padding: "5px 12px", fontSize: 12, fontWeight: 600, cursor: hasPrev && !nvdLoading ? "pointer" : "not-allowed", color: hasPrev && !nvdLoading ? "#475569" : "#c0ccd8", transition: "all .15s" }}>
                          <ChevronLeft />Prev
                        </button>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
                          {globalDocIndex >= 0 && <span style={{ fontSize: 12, fontWeight: 700, color: "#1d4ed8" }}>{globalDocIndex + 1} / {nvdTotalCount}</span>}
                          {selectedTotalRow && (
                            <span style={{ fontSize: 10, color: "#94a3b8", maxWidth: 160, textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {selectedTotalRow.NVD_Prakaran_kramank || (selectedTotalRow.NVD_doctype || "").replace(/^\d+\.\s*/, "")}
                            </span>
                          )}
                          {nvdLoading && <div className="vd-spin" style={{ width: 12, height: 12, border: "2px solid #e2e8f0", borderTopColor: "#1d4ed8", borderRadius: "50%" }} />}
                        </div>
                        <button className="vd-nav-btn" onClick={handleNextDoc} disabled={!hasNext || nvdLoading}
                          style={{ display: "flex", alignItems: "center", gap: 4, background: hasNext && !nvdLoading ? "#f1f5f9" : "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 5, padding: "5px 12px", fontSize: 12, fontWeight: 600, cursor: hasNext && !nvdLoading ? "pointer" : "not-allowed", color: hasNext && !nvdLoading ? "#475569" : "#c0ccd8", transition: "all .15s" }}>
                          Next<ChevronRightNav />
                        </button>
                      </div>

                      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: 20, boxShadow: "0 1px 3px rgba(0,0,0,.04)" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 700, color: "#1e293b", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #f1f5f9" }}>
                          <DocIcon />Nivada Information
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                          {[
                            { label: "Prakaran Kramank", value: selectedDoc.NVD_Prakaran_kramank },
                            { label: "Project Name", value: selectedDoc.master_project_name },
                            { label: "Volume No", value: selectedDoc.volume_no },
                            { label: "Page No", value: selectedDoc.PAGE_NO },
                            { label: "District", value: selectedDoc.district },
                            { label: "Tahsil", value: selectedDoc.tahsil },
                            { label: "Village", value: selectedDoc.village },
                            { label: "Office", value: selectedDoc.Nvd_office },
                            { label: "Yantrana", value: selectedDoc.NVD_Yantrana },
                            { label: "Acquired For", value: selectedDoc.Nvd_acquired_for },
                            { label: "Document Type", value: selectedDoc.NVD_doctype?.replace(/^\d+\.\s*/, "") },
                          ].map(({ label, value }) => {
                            const empty = value === null || value === undefined || value === "";
                            return (
                              <div key={label} style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                                <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", color: "#94a3b8" }}>{label}</span>
                                <span style={{ fontSize: 13, fontWeight: empty ? 400 : 600, color: empty ? "#cbd5e1" : "#1e293b", fontStyle: empty ? "italic" : "normal" }}>
                                  {empty ? "—" : String(value)}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {selectedDoc.NVD_Prakaran_kramank && (
                        <OwnersPanel prakaranKramank={selectedDoc.NVD_Prakaran_kramank} />
                      )}
                    </div>
                  )
                )}
              </div>
            ) : (
              <CollapsedTab label="Detail" icon={<InfoIcon />} onClick={() => togglePanel("detail")} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}